export default {"src":"/uk/_next/static/media/portfolio-money.4628901e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};